<script setup>
import { computed } from 'vue';
import { SpeakerWaveIcon, SpeakerXMarkIcon } from '@heroicons/vue/24/outline';

const props = defineProps({
    isMuted: { type: Boolean, default: true },
    currentTime: { type: Number, default: 0 },
    duration: { type: Number, default: 0 },
    showProgress: { type: Boolean, default: true },
    showMuteButton: { type: Boolean, default: true },
});

const emit = defineEmits(['toggle-mute']);

// Computed properties
const progress = computed(() => {
    if (props.duration === 0) return 0;
    return (props.currentTime / props.duration) * 100;
});
</script>

<template>
    <div class="absolute bottom-0 left-0 right-0 z-20">
        <!-- Progress Bar -->
        <div 
            v-if="showProgress"
            class="w-full h-1 bg-gray-600 bg-opacity-50"
        >
            <div
                :style="{ width: `${progress}%` }"
                class="h-full bg-red-500 transition-all duration-100 ease-linear"
            />
        </div>

        <!-- Controls -->
        <div v-if="showMuteButton" class="absolute bottom-4 right-4">
            <!-- Mute Toggle -->
            <button
                @click="emit('toggle-mute')"
                class="p-2 bg-black bg-opacity-50 rounded-full text-white hover:bg-opacity-70 transition-opacity"
                type="button"
                :aria-label="isMuted ? 'Unmute' : 'Mute'"
            >
                <SpeakerXMarkIcon v-if="isMuted" class="w-5 h-5" />
                <SpeakerWaveIcon v-else class="w-5 h-5" />
            </button>
        </div>
    </div>
</template>